// src/components/PortalFooter.jsx
// Bunntekst på kundesidene (lenkene kunden får på SMS og e-post) med lenke til
// personvernerklæringen og servicebetingelsene på roykensykkelservice.no.
// Én personvernerklæring for hele systemet (G3 i royken-sykkelservice).
import React from "react";
import { useLocation } from "react-router-dom";
import { erKundeside } from "../kundesider";


const NETTSIDE = "https://roykensykkelservice.no";

export default function PortalFooter() {
  const { pathname } = useLocation();
  if (!erKundeside(pathname)) return null;
  // Pristilbud, kundeordre og trykk fra butikken: servicebetingelsene gjelder verkstedet, ikke varer.
  const tilbud = /^\/(tilbud|kundeordre|kundetrykk)\//.test(pathname);

  return (
    <footer className="mx-auto w-full max-w-4xl px-4 pb-8 pt-4 text-sm text-gray-700 border-t border-gray-200 mt-4">
      <a href={`${NETTSIDE}/personvern`} target="_blank" rel="noopener noreferrer" className="underline text-blue-700">
        Personvernerklæring
      </a>
      {!tilbud && (
        <>
          <span aria-hidden="true" className="mx-2">·</span>
          <a href={`${NETTSIDE}/salgsbetingelser`} target="_blank" rel="noopener noreferrer" className="underline text-blue-700">
            Servicebetingelser
          </a>
        </>
      )}
    </footer>
  );
}
